import React from 'react';
import { initialChannels } from '../data/demoChannels';

export function Channels() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
      <div>
        <h2 style={{ fontSize: '18px', fontWeight: 700, color: '#09090B' }}>Campaign & Channel Performance</h2>

      </div>

      {/* Summary KPI Cards from Client Reports */}
      <div className="grid-4">
        <div className="card" style={{ padding: '16px 20px' }}>
          <div style={{ fontSize: '12.5px', color: '#71717A', fontWeight: 500 }}>FB Impressions</div>
          <div style={{ fontSize: '24px', fontWeight: 700, color: '#09090B', marginTop: '4px' }}>253.7K</div>
          <div style={{ fontSize: '11.5px', color: '#059669', marginTop: '2px' }}>54.3K Reach</div>
        </div>

        <div className="card" style={{ padding: '16px 20px' }}>
          <div style={{ fontSize: '12.5px', color: '#71717A', fontWeight: 500 }}>FB Amount Spent</div>
          <div style={{ fontSize: '24px', fontWeight: 700, color: '#09090B', marginTop: '4px' }}>฿116.8K</div>
          <div style={{ fontSize: '11.5px', color: '#71717A', marginTop: '2px' }}>Avg CPL ฿667.5</div>
        </div>

        <div className="card" style={{ padding: '16px 20px' }}>
          <div style={{ fontSize: '12.5px', color: '#71717A', fontWeight: 500 }}>Google Clicks</div>
          <div style={{ fontSize: '24px', fontWeight: 700, color: '#09090B', marginTop: '4px' }}>1,389</div>
          <div style={{ fontSize: '11.5px', color: '#059669', marginTop: '2px' }}>6.94% CTR</div>
        </div>

        <div className="card" style={{ padding: '16px 20px' }}>
          <div style={{ fontSize: '12.5px', color: '#71717A', fontWeight: 500 }}>Google Conversions</div>
          <div style={{ fontSize: '24px', fontWeight: 700, color: '#09090B', marginTop: '4px' }}>81.89</div>
          <div style={{ fontSize: '11.5px', color: '#059669', marginTop: '2px' }}>Cost/conv ฿297.94</div>
        </div>
      </div>

      {/* Main Campaign Breakdown Table */}
      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        <div style={{ padding: '16px 20px', borderBottom: '1px solid #E4E4E7' }}>
          <h3 className="card-title">Ads Campaign Performance Matrix</h3>
          <div style={{ fontSize: '12px', color: '#71717A', marginTop: '2px' }}>Detailed breakdowns per AdSet and campaign source</div>
        </div>

        <div className="table-responsive">
          <table className="custom-table">
            <thead>
              <tr>
                <th>Campaign Name</th>
                <th>Project / Source</th>
                <th>Reach / Clicks</th>
                <th>Impressions</th>
                <th>CPC</th>
                <th>Leads (all)</th>
                <th>Cost per Lead (CPL)</th>
                <th>Amount Spent</th>
              </tr>
            </thead>
            <tbody>
              {initialChannels.map((ch) => (
                <tr key={ch.id}>
                  <td>
                    <div style={{ fontWeight: 600, color: '#09090B' }}>{ch.name}</div>
                  </td>
                  <td>
                    <span style={{ fontSize: '12px', padding: '2px 8px', borderRadius: '4px', backgroundColor: ch.channelGroup === 'Google Ads' ? '#CCFBF1' : '#E8F2FE', color: ch.channelGroup === 'Google Ads' ? '#0F766E' : '#1877F2', fontWeight: 600 }}>
                      {ch.channelGroup}
                    </span>
                  </td>
                  <td style={{ color: '#09090B', fontWeight: 500 }}>{ch.reach}</td>
                  <td style={{ color: '#52525B' }}>{ch.impressions}</td>
                  <td style={{ fontFamily: 'var(--font-mono)' }}>{ch.cpc}</td>
                  <td style={{ fontWeight: 700, color: '#09090B' }}>{ch.leads}</td>
                  <td style={{ fontFamily: 'var(--font-mono)', fontWeight: 600, color: '#059669' }}>{ch.costPerLead}</td>
                  <td style={{ fontFamily: 'var(--font-mono)', fontWeight: 600 }}>{ch.amountSpent}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
